import angular from "angular";
import { Token } from "./common/data-access/model/token";
import { LocalConfig } from "./dto/local-config";
import { UrlParams } from "./dto/url-params";
import { IBuilderUrlService } from "./rest/builder-url/builder-url";
import type { BuilderUrlParams } from "./rest/builder-url/builder-url-params";
import { ProductType } from "./rest/builder-url/ProductType";
import { IClientService } from "./rest/client/client";
import { IInstanceService } from "./rest/instance/instance-rest";
import { BuilderViewConfig } from "./common/BuilderViewConfigInfo";



export class BuilderOrdinaryDetailController {
    // , "storeRestService"
    public static readonly $inject: string[] = ['$scope', '$window', '$timeout', '$sce', 'localConfig', 'instanceService', 'builderUrlService', 'clientService', '$translate'];
    // 获取完整token类型
    public token: Token;
    // 获取当前地址
    public rootPath: string;

    public appPath: string;
    // 获取iframe的高度
    public autoHeight: number;
    // s
    public isMobile: boolean;

    public isLoading: boolean = false;

    public redirectUrl: string;

    public cartItemKey: string;

    public wcProductId: number;

    public productInstanceId: string;

    public thumbnail: string;

    public wcOrderItemId: string;

    public wcOrderId: string;

    // public orderItemId: string;

    public propertyModelId: string | undefined;

    public attributeData: string;

    public qpsonInitVariationId: string;

    // public productId: string;

    // 根据storeProductId来判断获取builder接口地址
    public storeProductId?: string;

    public wcClientId: number | string;

    public qpsonStoreUrl: string;

    public wcUserName: string;

    public logo: string;

    public edit: boolean = true;

    public wpnonce: string;

    public paramData: string;

    public useTestVersion: boolean;

    public builderLanguage: string;

    public builderRegion: string;

    public isPreview: string | boolean;

    public showMask: string | boolean;

    public isOpenFileLibrary: boolean;
    // TODO 定义urlParams类型
    public urlParams: UrlParams;

    public builderUrlParams: BuilderUrlParams;

    public builderURL: string;

    public iwindow;

    public skuProductId: number;

    // public trustAsUrl;

    public myCartForm;

    public cancelForm;

    //*是否使用stage接口
    public isStage: boolean = false;

    public builderType: string;

    public isNewBuilderUrl: boolean = false;

    public hasDesign: boolean = false;

    public mockId: string;

    public storeType: string;

    public urlState: string;

    public isHideBottom: boolean = false;

    constructor(
        public $scope: angular.IScope,
        public $window: angular.IWindowService,
        public $timeout: angular.ITimeoutService,
        public $sce: angular.ISCEService,
        public localConfig: LocalConfig,
        public instanceService: IInstanceService,
        public builderUrlService: IBuilderUrlService,
        public clientService: IClientService,
        public $translate: angular.translate.ITranslateService
    ) {
        this.isMobile = this.mobileCheck();

        //* 通过URL参数判断传入加载builder类型 
        this.urlParams = this.parseQueryString(window.location.href);

        this.token = {
            access_token: "",
            token_type: ""
        }

        this.appPath = "/cgp-rest";

        if (this.urlParams.accessToken && this.urlParams.accessToken != "") {
            this.token.access_token = this.urlParams.accessToken;
            console.log({ accessToken: this.urlParams.accessToken });
        } else {
            console.error(this.urlParams);
            alert('The token passed in is empty,Please pass it in correctly.');
            throw new Error(`token is null`);
        }

        if (this.urlParams.tokenType && this.urlParams.tokenType != "") {
            this.token.token_type = this.urlParams.tokenType;
            console.log({ tokenType: this.urlParams.tokenType });
        } else {
            console.error(this.urlParams);
            alert('The tokenType passed in is empty,Please pass it in correctly.');
            throw new Error(`tokenType is null`);
        }

        if (this.urlParams.wcProductId && this.urlParams.wcProductId != "") {
            this.wcProductId = Number(this.urlParams.wcProductId);
        }

        if (this.urlParams.redirectUrl && this.urlParams.redirectUrl != "") {
            this.redirectUrl = this.urlParams.redirectUrl;
        }

        if (this.urlParams.cartItemKey && this.urlParams.cartItemKey != "") {
            this.cartItemKey = this.urlParams.cartItemKey
        }

        if (this.urlParams.wcOrderItemId && this.urlParams.wcOrderItemId != "") {
            this.wcOrderItemId = this.urlParams.wcOrderItemId;
        }

        if (this.urlParams.wcOrderId && this.urlParams.wcOrderId != "") {
            this.wcOrderId = this.urlParams.wcOrderId;
        }

        if (this.urlParams.storeProductId && this.urlParams.storeProductId != "") {
            this.storeProductId = this.urlParams.storeProductId;
        }

        if (this.urlParams.wcClientId && this.urlParams.wcClientId != "") {
            this.wcClientId = Number(this.urlParams.wcClientId);
            this.wcUserName = this.urlParams.wcUserName && this.urlParams.wcUserName != "" ? this.urlParams.wcUserName : "";
        }

        if (this.urlParams.qpsonStoreUrl && this.urlParams.qpsonStoreUrl != "") {
            this.qpsonStoreUrl = this.urlParams.qpsonStoreUrl;
        }

        if (this.urlParams._wpnonce && this.urlParams._wpnonce != "") {
            this.wpnonce = this.urlParams._wpnonce;
        }
        if (this.urlParams.propertyModelId && this.urlParams.propertyModelId != "") {
            this.propertyModelId = this.urlParams.propertyModelId;
        }

        if (this.urlParams.attributeData && this.urlParams.attributeData != "") {
            this.attributeData = this.urlParams.attributeData;
        }

        if (this.urlParams.qpsonIsSave && this.urlParams.qpsonIsSave != "") {
            this.hasDesign = true;
        }

        if (this.urlParams.qpsonInitVariationId && this.urlParams.qpsonInitVariationId != "") {
            this.qpsonInitVariationId = this.urlParams.qpsonInitVariationId;
        }

        //*TODO : storeProductId 
        //* 1.预览的 isPreview == "true"只传 productInstanceId
        //* 2.定制的 productInstanceId 和 storeProductId 一定有
        //* 3.定制的 propertyModelId 和 storeProductId 一定有

        //*TODO - 旧接口
        //* 1.预览： productInstanceId 和 isPreview == "true"
        //* 2.定制  productInstanceId
        //* 3.定制  propertyModelId
        //* 4.定制  storeProductId

        if (this.urlParams.isPreview === "true" && this.urlParams.productInstanceId) {
            this.productInstanceId = this.urlParams.productInstanceId;
            this.paramData = `?productInstanceId=${this.productInstanceId}`;
            this.isNewBuilderUrl = true;
        }

        // if (this.urlParams.productType === 'sku' && this.urlParams.storeProductId) {
        //     this.storeProductId = this.urlParams.storeProductId;
        //     this.paramData = `?storeProductId=${this.storeProductId}`;
        //     this.isNewBuilderUrl = true;
        // }

        if (this.urlParams.productInstanceId && this.urlParams.storeProductId) {
            this.productInstanceId = this.urlParams.productInstanceId;
            this.storeProductId = this.urlParams.storeProductId;
            this.paramData = `?productInstanceId=${this.productInstanceId}&storeProductId=${this.storeProductId}`;
            this.isNewBuilderUrl = true;
        } else if (this.urlParams.propertyModelId && this.urlParams.storeProductId) {
            this.propertyModelId = this.urlParams.propertyModelId;
            this.storeProductId = this.urlParams.storeProductId;
            this.paramData = `?propertyModelId=${this.propertyModelId}&storeProductId=${this.storeProductId}`;
            this.isNewBuilderUrl = true;
        } else {
            if (this.urlParams.productInstanceId) {
                this.productInstanceId = this.urlParams.productInstanceId;
                this.paramData = "?productInstanceId=" + this.productInstanceId;
            }
            else if (this.urlParams.storeProductId && this.urlParams.storeProductId != "") {
                this.storeProductId = this.urlParams.storeProductId;
                this.paramData = "?storeProductId=" + this.storeProductId;
            } else {
                this.propertyModelId = this.urlParams.propertyModelId;
                this.paramData = "?propertyModelId=" + this.propertyModelId;
            }
        }

        if (this.urlParams.productType === ProductType.SKU || this.urlParams.productType === ProductType.VARIABLE) {
            this.paramData += "&productType=" + ProductType.SKU;
        } else if (this.urlParams.productType === ProductType.CONFIGURABLE) {
            this.paramData += "&productType=" + ProductType.CONFIGURABLE;
        } else {
            //*TODO - 临时处理 没有给 productType 默认为 SKU
            this.paramData += "&productType=" + ProductType.SKU;
        }

        if (this.urlParams.useTestVersion != null && this.urlParams.useTestVersion != undefined) {
            this.paramData += "&useTestVersion=" + this.urlParams.useTestVersion;
            this.useTestVersion = this.getBoolean(this.urlParams.useTestVersion);
        } else {
            this.useTestVersion = false;
        }

        //*通过参数来判断是否使用stage
        if (this.urlParams.isStage && this.urlParams.isStage != "" && this.getBoolean(this.urlParams.isStage)) {
            this.isStage = true;
        }

        // 默认店铺类型为woocommerce
        if (!this.urlParams.platform) {
            this.storeType = "woocommerce"
        } else {
            this.storeType = this.urlParams.platform;
        }

        //状态是否stage状态
        //($1).xxx.com 判断$1，是否包含stage
        //区分程序是release/stage状态，取不同的环境配置
        if (window.location && window.location.origin.indexOf("stage") >= 0) {
            this.urlState = "stage"
        } else {
            this.urlState = "release"
        }


        //URL要不要接stage路径
        //用现在已知当前页面的设计时URL Path，将URL split，取前面[0]；当前页面请求的URL Path，是否已stage开头。
        this.rootPath = ((window.location && window.location.href && window.location.pathname.indexOf("/stage") >= 0) || this.isStage) ? `${window.location.protocol}//${window.location.host}/stage` : `${window.location.protocol}//${window.location.host}`;

        this.urlParams.themes && (this.paramData += "&themes=" + this.urlParams.themes);

        this.urlParams.logo && this.urlParams.logo != "" && (this.logo = this.urlParams.logo);

        // 多语言设置
        let language = "";
        this.builderLanguage = this.urlParams.language ?? "";
        this.builderRegion = this.urlParams.region ?? "";
        if (BuilderViewConfig.SUPPORT_LANGUAGE.indexOf(this.builderLanguage + "_" + this.builderRegion) > -1) {
            // 设置为url传入的语言
            language = this.builderLanguage + "_" + this.builderRegion;
        } else if (this.builderLanguage && BuilderViewConfig.SUPPORT_LANGUAGE.indexOf(this.builderLanguage) > -1) {
            language = this.builderLanguage;
            this.builderRegion = "";
        } else {
            // 设置为默认语言
            language = BuilderViewConfig.DEFAULT_REGION ? BuilderViewConfig.DEFAULT_LANGUAGE + "_" + BuilderViewConfig.DEFAULT_REGION : BuilderViewConfig.DEFAULT_LANGUAGE;
            this.builderLanguage = BuilderViewConfig.DEFAULT_LANGUAGE;
            this.builderRegion = BuilderViewConfig.DEFAULT_REGION;
        }

        $translate.use(language);
        // head-title标签的内容
        document.title = this.$translate.instant('Custom Design');

        this.builderRegion = this.urlParams.region || localConfig.defaultBuilderRegion;

        this.isPreview = (this.urlParams.isPreview && this.urlParams.isPreview != "") ? this.getBoolean(this.urlParams.isPreview) : false;

        this.showMask = (this.urlParams.showMask && this.urlParams.showMask != "") ? this.getBoolean(this.urlParams.showMask) : true;

        this.isOpenFileLibrary = angular.isUndefined(this.urlParams.isOpenFileLibrary) ? true : this.getBoolean(this.urlParams.isOpenFileLibrary as boolean);

        this.isOpenFileLibrary = angular.isUndefined(this.urlParams.isOpenFileLibrary) ? true : this.getBoolean(this.urlParams.isOpenFileLibrary as boolean);

        this.builderType = this.isPreview ? "UserPreview" : "EShop";

        //*TODO - 通过方法获取
        this.builderUrlParams = this.builderUrlService.getBuilderUrlParams(this.urlParams);

        angular.element($window).bind('resize', this.resizeFrame);
        this.getBuilderConfig = this.getBuilderConfig.bind(this);
        this.expired = this.expired.bind(this);
        this.loaded = this.loaded.bind(this);
        this.rejected = this.rejected.bind(this);
        this.toCartCallback = this.toCartCallback.bind(this);
        this.toOrderCallback = this.toOrderCallback.bind(this);
        this.test = this.test.bind(this);

        if (this.isMobile) {
            window.addEventListener("message", (event) => {
                if (event && event.data && angular.isString(event.data) && event.data !== "" && event.data !== "null" && event.data !== "undefined") {
                    let eventData = JSON.parse(event.data);
                    if (eventData.type == "ON_HEAD_HIDDEN_AND_SHOW") {
                        this.$timeout(() => {
                            this.isHideBottom = eventData.result.isHide;
                            this.resizeFrame();
                        });
                    }
                }
            });
        }

    }

    public trustAsUrl = function (url: string) {
        return this.$sce.trustAsResourceUrl(url)
    }

    public getBuilderConfig(builderConfig) {
        builderConfig.partnerToken = this.token;
        builderConfig.language = this.builderLanguage;
        this.builderRegion && (builderConfig.region = this.builderRegion);
        builderConfig.rootPath = this.rootPath;
        builderConfig.showMask = this.showMask;
        builderConfig.isOpenFileLibrary = this.isOpenFileLibrary;
        this.logo && (builderConfig.logo = this.rootPath + '/file/file/' + this.logo);
        return builderConfig;
    }

    public $onInit() {
        this.isLoading = true;
        this.isLoading = false;
        this.resizeFrame();
        console.log(this.token);
        (window as any).builder = {
            api: {
                "initialized": this.getBuilderConfig,
                "expired": this.expired,
                "loaded": this.loaded,
                "rejected": this.rejected
            }
        }

        this.builderUrlService.getBuilderUrl(this.token, this.builderUrlParams, this.isNewBuilderUrl).then((resp) => {
            if (resp.success && angular.isNumber(this.wcClientId)) {
                this.clientService.getClientInfo(Number(this.wcClientId), this.wcUserName, this.token, this.qpsonStoreUrl).then((clientResp) => {
                    this.builderURL = this.rootPath + resp.data + this.paramData + "&clientId=" + clientResp;
                    this.trustAsUrl(this.builderURL);
                }, (error) => {
                    //*无法获取客人用户信息的处理
                    this.builderURL = this.rootPath + resp.data + this.paramData + "&clientId=-1";
                    this.trustAsUrl(this.builderURL);
                    console.error(error);
                });
            } else if (resp.data) {
                //*没有wcClientId的情况
                this.builderURL = this.rootPath + resp.data + this.paramData;
                this.trustAsUrl(this.builderURL);
                console.log(resp.data + this.paramData);
            } else {
                //*报错提示
                console.error(resp.data);
            }
        }, function (err) {
            //*报错提示
            console.error(err);
        });




    }



    public expired() {
        return this.generateToken();
    }

    public resizeFrame = (() => {
        var winHeight = 0;

        //获取窗口高度
        if (window.innerHeight) {
            winHeight = window.innerHeight;
        } else if ((document.body) && (document.body.clientHeight)) {
            winHeight = document.body.clientHeight;
        }
        //通过深入Document内部对body进行检测，获取窗口大小
        else if (document.documentElement && document.documentElement.clientHeight) {
            winHeight = document.documentElement.clientHeight;
        }

        //设置div的具体宽度=窗口的宽度的%
        this.$timeout(() => {
            if (this.isPreview) {
                this.autoHeight = winHeight;
            } else {
                if (this.isMobile) {
                    this.autoHeight = this.isHideBottom ? winHeight : winHeight - 40;
                } else {
                    this.autoHeight = (winHeight - 48);
                }
            }
        });
    })


    public parseQueryString(url: string) {
        var query;
        if (url.indexOf("?") >= 0) {
            query = url.split("?")[1];
        } else {
            query = url;
        }
        var vars = query.split("&");
        var query_string = {}
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            var key = decodeURIComponent(pair[0]);
            var value = decodeURIComponent(pair[1]);
            // If first entry with this name
            if (typeof query_string[key] === "undefined") {
                query_string[key] = decodeURIComponent(value);
                // If second entry with this name
            } else if (typeof query_string[key] === "string") {
                var arr = [query_string[key], decodeURIComponent(value)];
                query_string[key] = arr;
                // If third or later entry with this name
            } else {
                query_string[key].push(decodeURIComponent(value));
            }
        }
        return query_string;
    }

    public getBoolean(value: string | boolean) {
        return (value != "" && value == "true") ? true : false;
    }


    //todo:token过期后的处理,目前WC未使用
    public generateToken = function () { }


    public loaded() {
        //获取到builder window;
        this.iwindow = window.frames['builderId'];
        if (angular.isFunction(this.iwindow.builder.addListener)) {
            this.iwindow.builder.addListener("check-completed", (() => {
                this.$timeout(() => {
                    this.isLoading = false;
                });
            }).bind(this));
        }
        this.$timeout(() => {
            this.isLoading = false;
        });
    }

    public rejected() {
        console.log('接收到builder装载拒绝通知');
    }

    //*保存Instance
    public saveProductInstance() {
        if (!this.isLoading) {
            this.isLoading = true;
            this.iwindow.builder.saveProductInstance({
                callback: this.test,
                instanceName: "product-instance",
                needCompleted: false
            });
        }
    }

    public test(productInstance: any) {
        console.log({ productInstance });
        if (this.cartItemKey) {
            this.redirectUrlHandle(productInstance, true);
        } else {
            if (!angular.isFunction(this.iwindow.builder.addListener)) {
                this.$timeout(function () {
                    this.isLoading = false;
                });
            }
        }
    }

    public redirectUrlHandle(instance: any, isCurrentOpen: boolean) {
        let openUrl = this.getOpenUrl(instance);
        openUrl ? (isCurrentOpen ? window.location.assign(openUrl) : window.open(openUrl)) : console.error("redirectUrl is null");
    }

    public getOpenUrl(instance: any) {
        var newUrl: null | string = null;
        if (instance && instance._id && this.redirectUrl && this.cartItemKey && instance.productId) {
            newUrl = this.checkUrl(this.redirectUrl) ? this.redirectUrl + '?' : this.redirectUrl + '/?';
            newUrl = `${newUrl}productInstanceId=${instance._id}&cartItemKey=${this.cartItemKey}&wpnonce=${this.wpnonce}&skuProductId=${instance.productId}&propertyModelId=${instance.propertyModelId}`;
            if (instance.mockup && instance.mockup.images.length > 0 && instance.mockup.images[0].tempFileName != "" && instance.mockup.images[0].tempFileName != undefined) {
                let thumbnail
                if (this.storeType === 'shopify') {
                    thumbnail = instance.mockup.images[0].fileName;
                } else {
                    thumbnail = instance.mockup.images[0].tempFileName;
                }
                let mockId = instance.mockup.images[0].id;
                newUrl = `${newUrl}&thumbnail=${thumbnail}&mockId=${mockId}`
            } else {
                if (instance.thumbnail && instance.thumbnail != "") {
                    let thumbnail
                    if (this.storeType === 'shopify') {
                        thumbnail = "composingPreview/" + instance.thumbnail;
                    } else {
                        thumbnail = instance.thumbnail;
                    }
                    newUrl = `${newUrl}&thumbnail=${thumbnail}`
                }
            }
        }
        return newUrl;
    }

    //*检查URL 是否存在？
    public checkUrl(url: string) {
        return url.substr(url.length - 1, 1) == '/' ? true : false;
    }

    //*添加到购物车处理
    public formSubmit() {
        this.myCartForm = this.myCartForm ? this.myCartForm : document.getElementById("myCartForm");
        this.myCartForm.action = this.redirectUrl;
        console.log(this.myCartForm);
        if (!this.isLoading) {
            this.isLoading = true;
            this.iwindow.builder.saveProductInstance({
                callback: this.toCartCallback,
                instanceName: "cart-instance",
                needCompleted: false
            });
        }
    }

    public toCartCallback(productInstance) {
        this.productInstanceId = productInstance._id;
        if (productInstance.mockup && productInstance.mockup.images.length > 0 && productInstance.mockup.images[0].tempFileName != "" && productInstance.mockup.images[0].tempFileName != undefined) {
            this.mockId = productInstance.mockup.images[0].id;
            if (this.storeType === 'shopify') {
                this.thumbnail = productInstance.mockup.images[0].fileName;
            } else {
                this.thumbnail = productInstance.mockup.images[0].tempFileName;
            }
        } else {
            if (this.storeType === 'shopify') {
                this.thumbnail = "composingPreview/" + productInstance.thumbnail;
            } else {
                this.thumbnail = productInstance.thumbnail;
            }
        }
        this.skuProductId = productInstance.productId;
        this.propertyModelId = productInstance.propertyModelId
        this.$timeout(() => {
            this.myCartForm && this.myCartForm.submit();
        });
    }

    public cancel = function () {
        if (this.qpsonStoreUrl) {
            this.cancelForm = this.cancelForm ? this.cancelForm : document.getElementById("cancelForm");
            this.cancelForm.action = this.redirectUrl;
            this.$timeout(() => {
                this.cancelForm && this.cancelForm.submit();
            });
        } else {
            window.location.assign(this.redirectUrl)
        }

    }

    public saveInstanceToOrder = function () {
        if (!this.isLoading) {
            this.isLoading = true;
            this.iwindow.builder.saveProductInstance({
                callback: this.toOrderCallback,
                instanceName: "order-instance",
                needCompleted: false
            });
        }
    }

    public toOrderCallback(productInstance: any) {
        this.instanceService.updateOrder(this.wcOrderId, this.wcOrderItemId, productInstance, this.token, this.rootPath).then((data) => {
            if (data.success) {
                alert("update Order succeed");
            } else {
                console.error(data);
                alert("update Order error");
            }
        }).catch((error) => {
            console.error(error);
            alert("update Order error");
        });
    }


    public mobileCheck() {
        let isMobile = false;
        let ua = navigator.userAgent || navigator.vendor || (window as any).opera;
        if (ua) {
            //*存在userAgent属性的时候判断方法
            //*todo：目前 包含 iPad 在在内，也算在移动端
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(ua.substr(0, 4))) {
                isMobile = true;
            }
            //todo 判断移动端系统
            if (isMobile) {
                let nua = window.navigator.userAgent.toLocaleLowerCase();
                // let isAndroid = /android/.test(nua);
                // let isIOS = /iphone|ipad|ipod/.test(nua);
                // if (isAndroid) {
                //     runtimeContext.builder.equipmentType = EquipmentType.ANDROID;
                //     runtimeContext.builder.isIPhone = false;
                // } else if (isIOS) {
                //     runtimeContext.builder.equipmentType = EquipmentType.IOS;
                //     runtimeContext.builder.isIPhone = true;
                // }
            } else if (window.innerWidth < 1153 || (typeof window.orientation !== 'undefined' && window.orientation !== 0 && window.orientation !== 180)) {
                isMobile = true;
            }
        } else if (window.innerWidth < 1153 || (typeof window.orientation !== 'undefined' && window.orientation !== 0 && window.orientation !== 180)) {
            //*window.orientation 为旋转角度 ipad：90或 - 90横屏 ipad：0或180竖屏 Andriod：0或180横屏 Andriod：90或 - 90竖屏
            // todo :ipad的横屏处理 特殊 后期兼容 ipad时 添加处理
            //*不存在userAgent属性时的判断方法
            //*屏幕尺寸过小
            //*window.orientation属性用于获取屏幕的当前方向，只有移动设备才有这个属性，桌面设备会返回undefined
            isMobile = true;
        }
        return isMobile;
    }
}